import React from 'react';

type TargetUniqueAttributeTableProps = {
    payload: TRecategorizePayload;
    recategorizationResponse: RecategorizationResponse | undefined;
}

const TargetUniqueAttributeTable = ({ payload, recategorizationResponse }: TargetUniqueAttributeTableProps) => {

    const getMappedSourceAttribute = (targetAttributeId: string) => {
        return payload.unique_attr_source_list.find(
            attr => attr.target_attribute_id === targetAttributeId && attr.checked
        );
    };

    return (
        <div className="tw-w-full tw-max-w-4xl tw-mx-auto tw-bg-white tw-mt-3">
            <div className="tw-flex tw-flex-col">
                <table className="tw-w-full">
                    <thead className="tw-bg-[#F4F5F7] tw-rounded-t-lg">
                        <tr className="tw-border-[1px] tw-border-[#DADBDD] tw-rounded-t-lg">
                            <th className="tw-w-12 tw-pl-4 tw-py-3 tw-rounded-tl-lg"></th>
                            <th className="tw-py-3 tw-text-left tw-font-semibold tw-text-sm tw-text-[#6D788C]">{payload.source_category_name}</th>
                            <th className="tw-py-3 tw-text-left tw-font-semibold tw-text-sm tw-text-[#6D788C]">Performed Action</th>
                            <th className="tw-py-3 tw-text-left tw-font-semibold tw-text-sm tw-text-[#6D788C]">{payload.target_category_name}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {recategorizationResponse?.unique_attr_target_list?.map((row, index) => {
                            const mappedSourceAttr = getMappedSourceAttribute(row.attribute_id);
                            return (
                                <React.Fragment key={row?.attribute_id}>
                                    <tr className={`tw-border tw-border-[#DADBDD] ${index % 2 === 0 ? 'tw-bg-white' : 'tw-bg-[#F4F5F7]'}`}>
                                        <td className="tw-w-12 tw-pl-4 tw-py-4">
                                            <label className="tw-relative tw-flex tw-items-center tw-justify-center tw-opacity-50">

                                                <div className="tw-w-4 tw-h-4 tw-flex tw-items-center tw-justify-center tw-border-2 tw-rounded-[4px] tw-border-[#091CAA] tw-border-opacity-25 tw-cursor-not-allowed">
                                                    <input type="checkbox" checked={true} disabled={true} />
                                                </div>
                                            </label>
                                        </td>
                                        <td className="tw-py-4 tw-text-[#172B4D] tw-text-sm">
                                            {mappedSourceAttr ? mappedSourceAttr.attribute_name : 'NA'}
                                        </td>
                                        <td className="tw-py-4 tw-text-[#172B4D] tw-text-sm">
                                            {mappedSourceAttr && (
                                                <div className="tw-w-[98px] tw-h-[30px] tw-px-2.5 tw-py-2 tw-bg-[#dadbdd] tw-rounded-[34px] tw-border tw-border-[#969fae] tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex">
                                                    <div className="tw-text-[#172b4d] tw-text-xs tw-font-normal tw-font-[Noto Sans] tw-leading-tight">
                                                        {mappedSourceAttr.action}
                                                    </div>
                                                </div>
                                            )}
                                        </td>
                                        <td className="tw-py-4 tw-text-[#172B4D] tw-text-sm">
                                            {row.attribute_name}
                                        </td>
                                    </tr>
                                </React.Fragment>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default TargetUniqueAttributeTable;